import React from "react";
import ICardWidgetProps from "../../../../../../model/interface/dataStorage/card/ICardWidgetProps";
import ICardWidgetContainer from "../../../../../../model/interface/dataStorage/card/ICardWidgetContainer";
import MainContainerWidget from "../../../widget/ContainerWidget";
import ConditionEditor from "../../../form/FormElement/optionEditor/ConditionEditor";
import Collapse from "../../../../../shared/display/collapse/Collapse";
import FilterEvaluationService from "../../../../../../model/service/api/FilterEvaluationService";
import {IAppState} from "../../../../../../redux/store";
import {connect} from "react-redux";
import IUser from "../../../../../../model/interface/security/IUser";
import IRestResource from "../../../../../../model/interface/api/IRestResource";
import {getBaseFieldsList} from "../../../../../../model/interface/api/IRestServiceFilters";
import ContentTypesService from "../../../../../../model/service/dataStorage/ContentTypesService";
import DataStorageHelper from "../../../../../../utils/DataStorageHelper";
import {debounce} from "underscore";

interface IState{
    conditionMet: boolean
}

interface IProps extends ICardWidgetProps<ICardWidgetContainer> {
    user: IUser
}

class ContainerWidget extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        const {options, resource, functions, user} = props
        this.state = {
            conditionMet: resource && options.filterConditions ? FilterEvaluationService.evaluate(options.filterConditions, resource, functions.getContentType(), user) : false
        }
        this.checkConditionalRequired = debounce(this.checkConditionalRequired, 800);
    }

    componentDidMount() {
        this.onChange()
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>) {
        this.onChange(prevProps);
    }

    onChange(prevProps?: Readonly<IProps>) {
        const {options, resource} = this.props

        if (!prevProps || (JSON.stringify(resource) !== JSON.stringify(prevProps.resource))) {
            if ((this.state.conditionMet || !prevProps) && options.remoteConditions) {
                this.checkConditionalRequired(resource, prevProps?.resource)
            }
        }
    }

    static getDerivedStateFromProps(props: ICardWidgetProps<ICardWidgetContainer>) {
        const {functions, preview, options, user, resource} = props
        if (resource && options.filterConditions) {
            return {conditionMet: FilterEvaluationService.evaluate(options.filterConditions, resource, functions.getContentType(), user)}
        }
        if (preview && options.conditions) {
            return {conditionMet: ConditionEditor.evaluateConditions(options.conditions, functions.getValue)}
        }
        return null
    }

    checkConditionalRequired = (original?: IRestResource, change?: IRestResource) => {
        const {functions, resource, options} = this.props
        if (original && options.remoteConditions && Object.keys(options.remoteConditions).length > 0) {
            const run = change ? getBaseFieldsList(options.remoteConditions).some(field => original[field] !== change[field]) : true
            if (run) {
                return ContentTypesService.evaluateRecordConditions({
                    filters: options.remoteConditions, resource: resource ? {
                        object: DataStorageHelper.shortenLongStringProperties(DataStorageHelper.buildFormData(resource, functions.getContentType())),
                        className: functions.getContentType().fullClassName
                    } : undefined
                }).then((r) => {
                    this.setState(state => ({conditionMet: (state.conditionMet || (!options.conditions && !options.filterConditions)) && r}))
                })
            }
        }
        return Promise.resolve()
    }

    render() {
        const {conditionMet} = this.state

        return (
            <div className={'overflow-hidden'}>
                <Collapse collapsed={conditionMet}>
                    <MainContainerWidget {...this.props}></MainContainerWidget>
                </Collapse>
            </div>

        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        user: state.setup.user
    }
}

export default connect(mapStateToProps)(ContainerWidget)